import api from '../../apiConfig/apiConfig';
import { Get, Post } from '../base/baseAjax';
export default {
	customerlist(params) {
		return Post({
			url: api.adsNewOnline.customerlist,
			bodyParam: params,
		});
	},
	classifyList(params) {
		return Get({
			url: api.adsNewOnline.classifyList,
			PathParam: params,
		});
	},
	pageList(params) {
		return Get({
			url: api.adsNewOnline.pageList,
			PathParam: params,
		});
	},
	productList(params) {
		return Post({
			url: api.adsNewOnline.productList,
			bodyParam: params,
		});
	},
	get_ads(params) {
		return Get({
			url: api.adsNewOnline.get_ads,
			PathParam: { automationId: params.automationId, type: params.type },
			UrlParam: { serviceSiteId: params.serviceSiteId },
		});
	},
	update_ads(bodyParam, PathParam) {
		return Post({
			url: api.adsNewOnline.update_ads,
			bodyParam: bodyParam,
			PathParam: PathParam,
		});
	},
	add_ads(PathParam, UrlParam) {
		return Get({
			url: api.adsNewOnline.add_ads,
			PathParam: PathParam,
			UrlParam: UrlParam,
		});
	},
	account_building(PathParam, UrlParam) {
		return Get({
			url: api.adsNewOnline.account_building,
			PathParam: PathParam,
			UrlParam: UrlParam,
			config: {
				timeout: 6000000,
			},
		});
	},
	logpage(params) {
		return Post({
			url: api.adsNewOnline.logpage,
			bodyParam: params,
		});
	},
	//方案
	addproduct(params) {
		return Post({
			url: api.adsNewOnline.addproduct,
			bodyParam: params,
		});
	},

	getproduct(params) {
		return Get({
			url: api.adsNewOnline.getproduct,
			PathParam: params,
		});
	},
	productdetail(params) {
		return Post({
			url: api.adsNewOnline.productdetail,
			bodyParam: params,
		});
	},
	addproductdetail(params) {
		return Post({
			url: api.adsNewOnline.addproductdetail,
			bodyParam: params,
		});
	},
	generate_keyword(params, UrlParam) {
		return Post({
			url: api.adsNewOnline.generate_keyword,
			bodyParam: params,
			UrlParam: UrlParam,
		});
	},
	productkeyword(params) {
		return Post({
			url: api.adsNewOnline.productkeyword,
			bodyParam: params,
		});
	},
	addproductkeyword(params) {
		return Post({
			url: api.adsNewOnline.addproductkeyword,
			bodyParam: params,
			config: {
				timeout: 60000,
			},
		});
	},
	getgeotargets(params) {
		return Post({
			url: api.adsNewOnline.getgeotargets,
			bodyParam: params,
		});
	},
	productregion(params) {
		return Get({
			url: api.adsNewOnline.productregion,
			PathParam: params,
		});
	},
	addproductregion(params) {
		return Post({
			url: api.adsNewOnline.addproductregion,
			bodyParam: params,
		});
	},
	productadditional(params) {
		return Get({
			url: api.adsNewOnline.productadditional,
			PathParam: params,
		});
	},
	addproductadditional(params) {
		return Post({
			url: api.adsNewOnline.addproductadditional,
			bodyParam: params,
		});
	},
	productdetailList(params) {
		return Get({
			url: api.adsNewOnline.productdetailList,
			PathParam: params,
		});
	},
	prdkeywordList(params) {
		return Get({
			url: api.adsNewOnline.prdkeywordList,
			PathParam: params,
		});
	},
	updatenotice(params) {
		return Get({
			url: api.adsNewOnline.updatenotice,
			PathParam: params,
		});
	},
	onlineconfirm(params) {
		return Get({
			url: api.adsNewOnline.onlineconfirm,
			PathParam: params,
		});
	},
	customerconfirm(params) {
		return Get({
			url: api.adsNewOnline.customerconfirm,
			PathParam: params,
		});
	},
	getPersonnel(params) {
		return Get({
			url: api.adsNewOnline.getPersonnel,
			UrlParam: params,
		});
	},
	getstepstatus(params) {
		return Get({
			url: api.adsNewOnline.getstepstatus,
			PathParam: params,
		});
	},
	getgroupList(params) {
		return Get({
			url: api.adsNewOnline.getgroupList,
			PathParam: params,
		});
	},
	geotargetsmatching(params) {
		return Post({
			url: api.adsNewOnline.geotargetsmatching,
			bodyParam: params,
		});
	},
	keywordHistorical(params, UrlParam) {
		return Post({
			url: api.adsNewOnline.keywordHistorical,
			bodyParam: params,
			UrlParam: UrlParam,
		});
	},
	keywordCheck(params) {
		return Post({
			url: api.adsNewOnline.keywordCheck,
			bodyParam: params,
		});
	},
	adLanguage() {
		return Get({
			url: api.adsNewOnline.adLanguage,
		});
	},
	keywordFoldable(params, UrlParam) {
		return Post({
			url: api.adsNewOnline.keywordFoldable,
			bodyParam: params,
			UrlParam: UrlParam,
		});
	},
	searchStatus(params) {
		return Post({
			url: api.adsNewOnline.searchStatus,
			bodyParam: params,
		});
	},
	adLanguages() {
		return Get({
			url: api.adsNewOnline.ad_languages,
		});
	},
	statistime() {
		return Post({
			url: api.adsNewOnline.statistime,
		});
	},
	addManufactureWord(params) {
		return Post({
			url: api.adsNewOnline.addManufactureWord,
			bodyParam: params,
		});
	},
	deleteManufactureWord(params) {
		return Get({
			url: api.adsNewOnline.deleteManufactureWord,
			PathParam: params,
		});
	},
	automaticrequestdata(params) {
		return Post({
			url: api.adsNewOnline.automaticrequestdata,
			bodyParam: params,
			config: {
				timeout: 60000,
			},
		});
	},
	semiautomaticrequestdata(params) {
		return Post({
			url: api.adsNewOnline.semiautomaticrequestdata,
			bodyParam: params,
			config: {
				timeout: 60000,
			},
		});
	},
	getmontagecontent(params) {
		return Post({
			url: api.adsNewOnline.getmontagecontent,
			bodyParam: params,
		});
	},
	listreturncontent(params) {
		return Post({
			url: api.adsNewOnline.listreturncontent,
			bodyParam: params,
		});
	},
	saveselecteddata(params) {
		return Post({
			url: api.adsNewOnline.saveselecteddata,
			bodyParam: params,
		});
	},
	productListAd(params) {
		return Post({
			url: api.adsNewOnline.productListAd,
			bodyParam: params,
		});
	},
	updateAdsAutoRegion(params) {
		return Post({
			url: api.adsNewOnline.updateAdsAutoRegion,
			bodyParam: params,
		});
	},
};
